import * as yup from 'yup'

const today = new Date()
today.setHours(0, 0, 0, 0) // Remove o horário para considerar apenas a data

export const schema = yup
    .object({
        titulo: yup.string().required('Campo obrigátorio'),
        descricao: yup
            .string()
            .min(10, 'Descrição deve ter pelo menos 10 caracteres')
            .max(500, 'Descrição deve ter no máximo 500 caracteres')
            .required('Campo obrigátorio'),
        dataExpiracao: yup
            .mixed<string>()
            .concat(yup.date())
            .transform((curr, orig) => (orig === '' ? null : curr))
            .test(
                'is-valid-date',
                'A data de expiração não pode ser anterior a hoje.',
                value => {
                    if (!value) return true // Permite `null` ou vazio por causa do `.nullable()`
                    const dateValue = new Date(value) // Converte para objeto Date
                    return !isNaN(dateValue.getTime()) && dateValue >= today // Verifica se é uma data válida e >= hoje
                }
            )
            .nullable()
    })
    .required()
